import React from 'react'
import LockIcon from '@material-ui/icons/Lock'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  default: {
    color: theme.palette.primary.main,
    fontSize: 16,
    verticalAlign: 'middle',
    marginLeft: theme.spacing(0.5),
  },
  select: {
    color: theme.palette.primary.main,
    fontSize: 16,
    verticalAlign: 'middle',
    marginRight: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  primaryButton: {
    color: theme.palette.background.paper,
    fontSize: 'inherit !important',
    verticalAlign: 'middle',
  },
  secondaryButton: {
    color: theme.palette.primary.main,
    fontSize: '16px !important',
    verticalAlign: 'middle',
  },
  label: {
    color: theme.palette.primary.main,
    fontSize: 14,
    verticalAlign: 'middle',
    marginLeft: theme.spacing(0.5),
    marginBottom: 2,
  },
}))

const LockIconComponent = ({ context = 'default', className, ...props }) => {
  const classes = useStyles()
  const combinedClass = clsx(classes[context] || classes.default, className)

  return <LockIcon className={combinedClass} {...props} />
}

LockIconComponent.defaultProps = {
  context: 'default',
  className: '',
}

LockIconComponent.propTypes = {
  context: PropTypes.string,
  className: PropTypes.string,
}

export default LockIconComponent
